module.exports = __webpack_public_path__ + "static/media/tti_with_talentx@3x.43ba4df7.png";